module.exports = __webpack_public_path__ + "img/logo_itwa.c0ce02d9.png";